<template>
  <div class="activities">
    <div class="title">
      <div></div>
      活动列表
    </div>
    <div class="query">
      <div class="query-box">
        <el-input v-model="query" placeholder="活动名称"></el-input>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="addShow = true">新增</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
        <el-table-column align="center" prop="activityName" label="活动名称">
        </el-table-column>
        <el-table-column align="center" prop="corporateName" label="所属公司">
        </el-table-column>

        <el-table-column align="center" prop="startTime" label="兑换码有效期">
          <template slot-scope="scope">
            {{ scope.row.startTime }}-{{ scope.row.endTime }}
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="activityCodeNumber"
          label="兑换码数量"
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="addVipDays"
          label="增加会员有效时间天数"
        >
        </el-table-column>
        <el-table-column align="center" prop="startTime" label="二维码">
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.orCode"
              :preview-src-list="[scope.row.orCode]"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="340">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="activityList(scope.row.id)"
              >兑换码列表</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="activityInfo(scope.row.id)"
              >活动详情</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="addCode(scope.row.orCode)"
              >下载二维码</el-button
            >
            <!-- <el-button size="mini" type="danger" @click="del(scope.row.id)"
                >删除</el-button
              > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="新增"
      :visible.sync="addShow"
      width="50%"
      @closed="handleClose"
    >
      <div class="main">
        <el-form ref="forms" :model="form" label-width="170px" :rules="rules">
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="form.activityName"
              placeholder="活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属公司" prop="corporateName">
            <el-input
              v-model="form.corporateName"
              placeholder="所属公司"
            ></el-input>
          </el-form-item>
          <el-form-item label="兑换码数量" prop="activityCodeNumber">
            <el-input
              type="number"
              v-model="form.activityCodeNumber"
              placeholder="兑换码数量"
              :min="0"
            ></el-input>
          </el-form-item>
          <el-form-item label="增加会员有效时间天数" prop="addVipDays">
            <el-input
              type="number"
              v-model="form.addVipDays"
              placeholder="增加会员有效时间天数"
              :min="0"
            ></el-input>
          </el-form-item>
          <el-form-item label="兑换码有效期" prop="activityTime">
            <el-date-picker
              format="yyyy-MM-dd HH:mm"
              v-model="form.activityTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="会员内容"
            label-position="right"
            class="form-label"
            prop="picture"
          >
            <el-upload
              class="avatar-uploader"
              :action="imgURL"
              :show-file-list="false"
              :on-success="coverSuccess"
            >
              <img
                style="width: 100px; height: 100px"
                v-if="form.picture"
                :src="form.picture"
                class="avatar"
              />
              <i
                style="width: 100px; height: 100px"
                v-else
                class="el-icon-plus avatar-uploader-icon"
              ></i>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit('forms')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 详情 -->
    <el-dialog title="活动详情" :visible.sync="infoShow" width="30%">
      <div class="info-main">
        <div class="box">
          <div class="box-right">
            活动名称：<span>{{ info.activityName }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-right">
            所属公司：<span>{{ info.corporateName }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-right">
            兑换码数里：<span>{{ info.activityCodeNumber }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-right">
            兑换码有效期：<span>{{ info.startTime }}-{{info.endTime   }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-right">
            增加会员有效时间天数：<span>{{ info.addVipDays }}</span>
          </div>
        </div>
        <div class="box">
          <div class="box-right">
            会员内容：<span>
                 <el-image
              style="width: 100px; height: 100px"
              :src="info.picture"
              :preview-src-list="[info.picture]"
            >
            </el-image></span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="infoShow = false">取 消</el-button>
        <el-button type="primary" @click="infoShow = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  
  <script>
import moment from "moment";
import local from "@/utils/local.js";
import { corporationPage, corporationAdd, IP,corporationInfo } from "@/api/api";
import reg from "@/utils/reg.js";
export default {
  data() {
    return {
      // 图片上传地址
      imgURL: IP + "/images/uploadImage",
      infoShow: false,
      ruleList: [],
      query: "",
      startTime: "",
      endTime: "",
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      types: "",
      type: "",
      addShow: false,
      form: {
        activityTime: "",
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityCodeNumber: "",
        activityCountTime: "",
        ddVipDays: "",
        corporateName: "",
        picture: "",
      },
      info: {
        activityTime: "",
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityCodeNumber: "",
        activityCountTime: "",
        ddVipDays: "",
        corporateName: "",
        picture: "",
      },
      rules: {
        //验证规则
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        activityCodeNumber: [
          {
            required: true,
            message: "请输入兑换码数量",
            trigger: "blur",
          },
        ],
        addVipDays: [
          {
            required: true,
            message: "请输入增加会员有效时间天数",
            trigger: "blur",
          },
        ],
        corporateName: [
          {
            required: true,
            message: "请输入所属公司",
            trigger: "blur",
          },
        ],
        picture: [
          {
            required: true,
            message: "请输入活动图片",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    addCode(code){
         window.open(code)
    },
    // 详情
    activityInfo(id){
        corporationInfo({id}).then(res=>{
          
                 this.infoShow=true
                 this.info=res.data
        })
    },
    // 上传会员内容图片
    coverSuccess(e) {
      console.log(e);
      this.form.picture = e;
    },
    // 新增
    addSubmit: reg._debounce(function (formName) {
      (this.form.startTime = moment(this.form.activityTime[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      )),
        (this.form.endTime = moment(this.form.activityTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        ));
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code, msg } = await corporationAdd({
            activityCodeNumber: this.form.activityCodeNumber,
            activityName: this.form.activityName,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            addVipDays: this.form.addVipDays,
            corporateName: this.form.corporateName,
            picture: this.form.picture,
          });

          if (code == 200) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.addShow = false;
            this.getList();
          }
        }
      });
    }, 200),
    // 关闭弹窗
    handleClose() {
      this.addShow = false;
      this.form = {
        activityTime: "",
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityCount: "",
        addVipDay: "",
      };
    },

    // 兑换码列表
    activityList(id) {
      this.$router.push("codeList?activityId=" + id);
    },

    //  获取活动列表
    async getList() {
      let res = await corporationPage({
        corporateName: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.list.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.list;
      this.total = data.total;
    },

    // 查询
    inquire() {
      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>
  
  <style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
.info-main {
  .box {
    display: flex;
    margin-bottom: 35px;
    .box-left {
      width: 300px;
      display: flex;
      align-items: center;
    }
    .box-label {
      display: flex;
      align-items: center;
      div {
        padding: 10px 20px;
        background: #ffb423;
        margin-left: 16px;
        border-radius: 5px;
      }
    }
    .box-img {
      margin-top: 23px;
      .img {
        width: 200px;
        height: 160px;
        margin-right: 26px;
        margin-bottom: 26px;
      }
    }
    .box-discounts {
      p {
        padding: 13px 30px 0;
        color: #727070;
      }
    }
  }
}
/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
/deep/.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  line-height: 100px;
  vertical-align: top;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  display: inline-block;
}
/deep/.el-upload-list__item-thumbnail {
  width: 100px;
  height: 100px;
}
</style>